import React from 'react';

import "./StatBox.css";

interface StatBoxProps {
    colWidth: number
    data: number
    percent: boolean
    title: string
}

export default function StatBox({colWidth, data, percent, title}: StatBoxProps) {
    return (
        <div className={`col-${colWidth}`}>
        <div className="stat-box-container">
            <div className="title">
                {title}
            </div>
            <div className="data">
                {data.toFixed(0)}
                {percent ? '%' : ''}
            </div>
        </div>
        </div>
    )
}